<template>
    <ul class="cemetery-occupations-list">
        <CemeterySectorOccupationItem
            v-for="(item, idx) in items"
            :key="`cemetery-occupation-item-${idx}`"
            :value="item"
            :cemeteryCode="cemeteryCode"
            :panelCfg="panelCfg"
            :baseTranslateID="baseTranslateID"
            :enableView="allowView"
            @view="onView" />
    </ul>
</template>

<script>
    import CemeteryElementMixin from "../mixins/CemeteryElementMixin";
    import { formatUrl, customMergeDeep } from '@config/utils';

    function initialState (){
        return {
            loaded: false,
            items: [],
            _actions: {},
        }
    }

    export default {
        mixins: [
            CemeteryElementMixin
        ],
        components: {
            CemeterySectorOccupationItem: () => import(/* webpackChunkName: "cemeteries-cemeterysectoroccupationitem" */ './CemeterySectorOccupationItem'),
        },
        props: {
            cemeteryCode: {
                type: [Number, String],
                default: null,
            },
            sectorId: {
                type: [Number, String],
                default: null,
            },
            isShow: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return initialState();
        },
        beforeDestroy() {
            this.reset();
        },
        computed: {
            allowView() {
                return this._actions?.show ?? false;
            },
        },
        methods: {
            reset() {
                Object.assign(this.$data, initialState());
            },
            async loadData() {
                if(!this.sectorId) {
                    return Promise.resolve(false);
                }

                if(this.loaded) {
                    return Promise.resolve(true);
                }

                let url = formatUrl(this.url.occupations, {cemetery: {code: this.cemeteryCode}, sector: {id: this.sectorId}})
                if(!url) return Promise.resolve(false);

                return await this.$http.get(url)
                .then(res => {
                    const {data, ...additional} = res.data;
                    this.items = data ?? [];
                    this._actions = additional.actions ?? {};
                    this.loaded = true;
                    return true;
                }).catch(error => {
                    this.loaded = false;
                    this.showHttpError(error);
                    return false;
                });
            },
            onView(params) {
                if(this.allowView) {
                    // this.reset();
                    this.$emit('selectItem', params);
                }
            },
        },
        watch: {
            isShow: {
                immediate: true,
                handler: function(value) {
                    if(value) {
                        this.loadData();
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.cemetery-occupations-list {
    padding: 0;
    margin: 0;
}
</style>